import { ARTIFACT_LABELS } from './constants'

export type ArtifactLabels = (typeof ARTIFACT_LABELS)[keyof typeof ARTIFACT_LABELS]

export const DocumentStatus = {
  ATIVO: 'ATIVO',
  INATIVO: 'INATIVO',
  REMOVIDO: 'REMOVIDO',
} as const
